<form class="permissions-form" (ngSubmit)="handleSubmit()">
  <!-- ==================================================
       User Access
       ================================================== -->

  <section class="settings-card">
    <div class="section-copy">
      <span class="section-kicker">Team Access</span>

      <h3>User Access</h3>

      <p>Review employee roles and current dashboard access levels.</p>
    </div>

    <div class="access-table">
      <div class="access-table__inner">
        <div class="access-head">
          <span>Employee</span>
          <span>Role</span>
          <span>Access</span>
          <span></span>
        </div>

        @if (isLoading) {
          <div class="access-empty">Loading team access...</div>
        } @else if (!users.length) {
          <div class="access-empty">No employees found.</div>
        } @else {
          @for (user of users; track user.user_id) {
            <div class="access-row" [class.is-inactive]="!user.is_active">
              <!-- Employee -->
              <div class="employee-cell">
                @if (user.avatar) {
                  <img [src]="user.avatar" [alt]="user.name" />
                } @else {
                  <div class="avatar-fallback">
                    {{ user.initials }}
                  </div>
                }

                <div>
                  <strong>
                    {{ user.name }}
                  </strong>

                  <span>
                    {{ user.email || "No email added" }}
                  </span>
                </div>
              </div>

              <!-- Role -->
              <div class="text-cell">
                {{ user.role }}
              </div>

              <!-- Access -->
              <div>
                <span
                  class="access-pill"
                  [class.access-pill--owner]="user.access === 'owner'"
                  [class.access-pill--admin]="user.access === 'admin'"
                  [class.access-pill--manager]="user.access === 'manager'"
                >
                  {{ getAccessLabel(user.access) }}
                </span>
              </div>

              <!-- Edit -->
              <div class="row-actions">
                @if (user.is_owner) {
                  <span class="owner-lock">Owner</span>
                } @else {
                  <div class="access-menu">
                    <button
                      type="button"
                      class="access-menu__trigger"
                      (click)="toggleUserMenu(user)"
                    >
                      Edit

                      <img [src]="assetUrl + 'icons/chevron-down.svg'" alt="" />
                    </button>

                    @if (openUserId === user.user_id) {
                      <div class="access-menu__dropdown">
                        <button
                          type="button"
                          (click)="setUserAccess(user, 'admin')"
                        >
                          Admin
                        </button>

                        <button
                          type="button"
                          (click)="setUserAccess(user, 'manager')"
                        >
                          Manager
                        </button>

                        <button
                          type="button"
                          (click)="setUserAccess(user, 'employee')"
                        >
                          Employee
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  </section>

  <!-- ==================================================
       Dashboard permissions
       ================================================== -->

  <section class="settings-card">
    <div class="section-copy">
      <span class="section-kicker">Admin Permissions</span>

      <h3>Dashboard Access</h3>

      <p>Control which business sections employees can view or manage.</p>
    </div>

    <div class="permission-list">
      @for (permission of permissions; track permission.key) {
        <div
          class="permission-card"
          [class.permission-card--enabled]="permission.enabled"
        >
          <button
            type="button"
            class="permission-toggle"
            [attr.aria-label]="'Toggle ' + permission.label"
            [attr.aria-pressed]="permission.enabled"
            (click)="togglePermission(permission)"
          >
            <glo-toggle [value]="permission.enabled"></glo-toggle>
          </button>

          <div>
            <strong>
              {{ permission.label }}
            </strong>

            <span>
              {{ permission.description }}
            </span>
          </div>
        </div>
      }
    </div>
  </section>

  <!-- ==================================================
       Footer
       ================================================== -->

  <div class="form-footer">
    <button
      type="button"
      class="light-btn"
      [disabled]="isSaving"
      (click)="resetChanges()"
    >
      Cancel
    </button>

    <button type="submit" class="dark-btn" [disabled]="isSaving || isLoading">
      {{ isSaving ? "Saving..." : "Save Changes" }}
    </button>
  </div>
</form>
